import type { ReactElement } from 'react';
import {
    BodySmallEmphasized,
    BodySmallRegular,
    FruitfulCustomIcon,
    XStack,
    YStack,
} from 'smoothie';

import type {
    AccountSummary,
    BankAccountDisplayDetail,
} from '../types/IncomeSplit';
import {
    getAccountSummaryName,
    getIncomeSplitAccountVisuals,
    isBankAccountDisplayDetail,
} from '../utils/incomeSplitAccountUtils';

export const Account = ({
    account,
    footer,
}: {
    account: BankAccountDisplayDetail | AccountSummary;
    footer?: ReactElement;
}) => {
    const accountNumberMasked = account.accountNumberMasked ?? '';
    const { icon, color } = getIncomeSplitAccountVisuals(account);
    const nickname = isBankAccountDisplayDetail(account)
        ? (account.nickname ?? getAccountSummaryName(account))
        : getAccountSummaryName(account);

    return (
        <XStack
            paddingVertical={12}
            paddingHorizontal={16}
            gap={16}
            alignItems="center"
            justifyContent="space-between"
        >
            <XStack gap={16} alignItems="center">
                <FruitfulCustomIcon icon={icon} color={color} size="xs" />
                <YStack>
                    <BodySmallEmphasized>{nickname}</BodySmallEmphasized>
                    <BodySmallRegular color="$gray1000">
                        {`Fruitful ${accountNumberMasked.slice(-5)}`}
                    </BodySmallRegular>
                </YStack>
            </XStack>
            {footer}
        </XStack>
    );
};
